import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img width='1910' className='img-fluid' src="https://kfg6bckb.media.zestyio.com/yalantis-interactive-404.gif" alt="" />
        </div>
    );
};

export default NotFound;